__turbopack_context__.v({
  "tenthScreenContainer": "MainForm-module-scss-module__1TmBoq__tenthScreenContainer",
  "tenthScreenFormBox": "MainForm-module-scss-module__1TmBoq__tenthScreenFormBox",
  "tenthScreenImg": "MainForm-module-scss-module__1TmBoq__tenthScreenImg",
  "tenthScreenImgBox": "MainForm-module-scss-module__1TmBoq__tenthScreenImgBox",
  "tenthScreenSvg": "MainForm-module-scss-module__1TmBoq__tenthScreenSvg",
  "tenthScreenWrapper": "MainForm-module-scss-module__1TmBoq__tenthScreenWrapper",
});
